import AdministracionRoutes from './administracion';
import SistemaRoutes from './sistema';

export default [].concat(
    AdministracionRoutes,
    SistemaRoutes,
);